export enum ChangeType {
  Add = 'add',
  Attributes = 'attributes',
  Bind = 'bind',
  Remove = 'remove',
  Replace = 'replace',
  Unbind = 'unbind',
  Untracked = 'untracked'
}
